import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {VoucherRequest} from "../../models/voucherRequest";

@Injectable({
    providedIn: "root"
})
export class VoucherRequestService {

    constructor (private http: HttpClient) { }

    /*
     * Le périmètre est décidé côté back : le staff voit toutes les demandes,
     * un responsable de centre uniquement celles de ses centres.
     */
    list (filters: {status?: string; examCenter?: number} = {}): Observable<Array<VoucherRequest>> {
        let params = new HttpParams();
        if (filters.status) {
            params = params.set(
                "status",
                filters.status
            );
        }
        if (filters.examCenter) {
            params = params.set(
                "exam_center",
                String(filters.examCenter)
            );
        }

        return this.http.get<Array<VoucherRequest>>(
            `${environment.baseApiUrl}/voucher_requests/`,
            {params}
        ).
            pipe(map((res: any) => res.map((d: any) => new VoucherRequest(d))));
    }
}
